const obj = {
    /**
     * 交易管理
     */
    //导出订单
    exportOrderApi: "/trade/platform/export/downloadExport",
    //  列表
    getBusinessOrderListInPlatform: "/trade/platform/queryOrders",
    //  详情
    getOrderDetail: "/trade/platform/orderdetail",
    //  物流信息
    getExpressageInfo: "/transport/expressage/getExpressageInfo",
    // 售后查看物流
    getReturnExpressageInfo: '/transport/expressage/getReturnExpressageInfo',
    //  评价列表
    getListGoodsSkuComment: "/goods/skucomment/getListGoodsSkuComment",
    // 查询投诉列表
    getListComplaint: "/goods/skucomment/complaint/platform/search",
    // 查询投诉详情
    getComplainDetail: "/goods/skucomment/complaint/platform/detail/",
    //  审核投诉
    complaintReview: "/goods/skucomment/complaint/review",
    //  隐藏开关
    hideSwitch: "/goods/skucomment/hideSwitch/",
    //  查看评价
    findGoodsSkuCommentById: "/goods/skucomment/findGoodsSkuCommentById",
    //  删除评价
    cancelGoodsSkuComment: "/goods/skucomment/cancelGoodsSkuComment",
    //  售后列表
    refundPage: "/trade/refund/platform/refundPage",
    //  售后详情
    refundDetail: "/trade/refund/platform/refundDetail",
    //申诉列表
    involvedPage: "/trade/refund/platform/involvedPage",
    //  审核
    auditRefund: "/trade/refund/platform/auditRefund",
    //  所属于店铺
    getStoreInfoListById: "/merchant/merchantInfo/getStoreInfoListById",
    //  所属的商家
    getMerchantInfoByName: "/merchant/merchantInfo/getMerchantInfoByName",
    // 推单失败原因
    traceDetail:"/trade/store/trace/detail",

    /*************************** 拼团3期优化添加接口 ****************************/
    //  修改自定义分类标签
    editCollageTab: "/promotion/audit/platform/editCollageTab",
    //  删除自定义分类标签
    removeCollageTab: "/promotion/audit/platform/removeCollageTab",
    //  批量对提报的商品删除标签
    batchRemoveTabApplyGoods: "/promotion/audit/platform/batchRemoveTabApplyGoods",
    //  批量对提报的商品添加标签
    batchAddTabApplyGoods: "/promotion/audit/platform/batchAddTabApplyGoods",
    //  拼团活动分类展示切换为不分类
    collageTabSwitchNoTab: "/promotion/audit/platform/collageTabSwitchNoTab",
    //  查询标签下的提报的商品分页主列表
    getTabApplyGoods: "/promotion/audit/platform/getTabApplyGoods",
    //  查询标签下的提报的商品分页选择列表
    getChoseTabApplyGoods: "/promotion/audit/platform/getChoseTabApplyGoods",
    //  查询自定义分类标签列表
    getCollageTabList: "/promotion/audit/platform/getCollageTabList/",
    //  添加自定义分类标签
    addCollageTab: "/promotion/audit/platform/addCollageTab",
    //  导出按条件查询出来的审核通过的商品列表
    exportNoTabApplyGoods: "/promotion/audit/platform/exportNoTabApplyGoods",
    orderRepush:"/trade/store/order/repush",    //推单
}

export default obj;
